import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { Button, ButtonGroup, Col, Row, Table } from "reactstrap";
import { SortHeader } from ".";
import { constants, dateHelpers, helpers } from "../utils";

export default function CustomerGrid(props) {
   const navigate = useNavigate();
   const [currentBalanceTotal, setCurrentBalanceTotal] = useState(0);
   const [data, setData] = useState();
   const [limitRows, setLimitRows] = useState(false);
   const [pastDueTotal, setPastDueTotal] = useState(0);
   const [ninetyPlusBalanceTotal, setNinetyPlusBalanceTotal] = useState(0);
   const [sixtyNinetyBalanceTotal, setSixtyNinetyBalanceTotal] = useState(0);
   const [thirtyDaysBalanceTotal, setThirtyDaysBalanceTotal] = useState(0);
   const [thirtySixtyBalanceTotal, setThirtySixtyBalanceTotal] = useState(0);
   const [working, setWorking] = useState(false);
   const [yearToDateSalesTotal, setYearToDateSalesTotal] = useState(0);

   useEffect(() => {
      if (data !== props.data) {
         setData(props.data)
         setCurrentBalanceTotal(props.data.reduce((total, currentItem) => total = total + currentItem.customerBalance, 0));
         setThirtyDaysBalanceTotal(props.data.reduce((total, currentItem) => total = total + currentItem.balanceThirtyDays, 0));
         setThirtySixtyBalanceTotal(props.data.reduce((total, currentItem) => total = total + currentItem.balanceThirtySixty, 0));
         setSixtyNinetyBalanceTotal(props.data.reduce((total, currentItem) => total = total + currentItem.balanceSixtyNinety, 0));
         setNinetyPlusBalanceTotal(props.data.reduce((total, currentItem) => total = total + currentItem.balanceNinetyPlus, 0));
         setYearToDateSalesTotal(props.data.reduce((total, currentItem) => total = total + currentItem.yearToDateSales, 0));
         setPastDueTotal(props.data.reduce((total, currentItem) => total = total + currentItem.lateBalance, 0));
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [props.data])

   useEffect(() => {
      setWorking(true);
      props.setOverdueCallback(limitRows);
      setWorking(false);
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [limitRows])
  
   function getExcel() {
      setWorking(true);
      props.exportXlsxCallback();
      setWorking(false);
   }

   return (
      <>
         <Row className="align-items-center">
            <Col className="transparent-background">
               <div className="float-end InLineAttributes">
                  <div>
                     <input
                        type="checkbox"
                        id="limitRows"
                        name="limitRows"
                        checked={limitRows}
                        onChange={() => setLimitRows(!limitRows)}
                        style={{ height: "8px", width: "8px" }}
                     /> <label>Overdue Amounts Only?</label>
                  </div>
                  <div className="testingSpace"></div>
                  <div>
                     <ButtonGroup className="float-end">
                        {data && data.length && props.exportXlsxCallback && (
                           <Button
                              title="Download as .xlsx"
                              className="shredButtonExcel float-end ms-2"
                              onClick={getExcel}
                              disabled={working}
                           >
                              <FontAwesomeIcon icon="file-excel" size="lg" />
                           </Button>
                        )}
                     </ButtonGroup>
                  </div>
               </div>
            </Col>
         </Row>
         <Table size="sm" className="data-table">
            <thead className="table-header">
               <tr>
                  <th style={{ width: "20%" }}>
                     <SortHeader
                        displayName={<span>Customer</span>}
                        field="customerId"
                        sortDirection={props.sortDirection}
                        sorted={props.sortField === "customerId"}
                        callback={props.sortCallback}
                     />
                  </th>
                  {props.showLateBalancesOnly
                     ? <th style={{ width: "8%" }}>
                        <SortHeader
                           displayName={<span>Payment <br /> Terms</span>}
                           field="paymentTerms"
                           sortDirection={props.sortDirection}
                           sorted={props.sortField === "paymentTerms"}
                           callback={props.sortCallback}
                        />
                     </th>
                     : null
                  }
                  {props.showLateBalancesOnly
                     ? <th style={{ width: "8%" }}>
                        <SortHeader
                           displayName={<span>Overdue <br /> Amount</span>}
                           field="lateBalance"
                           sortDirection={props.sortDirection}
                           sorted={props.sortField === "lateBalance"}
                           callback={props.sortCallback}
                        />
                     </th>
                     : null
                  }
                  {props.showLateBalancesOnly
                     ? <th style={{ width: "8%" }}>
                        <SortHeader
                           displayName={<span>Days <br /> Due</span>}
                           field="daysPastDue"
                           sortDirection={props.sortDirection}
                           sorted={props.sortField === "daysPastDue"}
                           callback={props.sortCallback}
                        />
                     </th>
                     : null
                  }
                  <th style={{ width: "10%" }}>
                     <SortHeader
                        displayName={<span>Current <br /> Balance</span>}
                        field="customerBalance"
                        sortDirection={props.sortDirection}
                        sorted={props.sortField === "customerBalance"}
                        callback={props.sortCallback}
                     />
                  </th>
                  <th style={{ width: "10%" }}>
                     <SortHeader
                        displayName={<span>Credit <br /> Limit</span>}
                        field="creditLimit"
                        sortDirection={props.sortDirection}
                        sorted={props.sortField === "creditLimit"}
                        callback={props.sortCallback}
                     />
                  </th>
                  <th style={{ width: "10%" }}>
                     <SortHeader
                        displayName={<span>Balance <br /> 0-30</span>}
                        field="balanceThirtyDays"
                        sortDirection={props.sortDirection}
                        sorted={props.sortField === "balanceThirtyDays"}
                        callback={props.sortCallback}
                     />
                  </th>
                  <th style={{ width: "10%" }}>
                     <SortHeader
                        displayName={<span>Balance <br /> 31-60</span>}
                        field="balanceThirtySixty"
                        sortDirection={props.sortDirection}
                        sorted={props.sortField === "balanceThirtySixty"}
                        callback={props.sortCallback}
                     />
                  </th>
                  <th style={{ width: "10%" }}>
                     <SortHeader
                        displayName={<span>Balance <br /> 60-90</span>}
                        field="balanceSixtyNinety"
                        sortDirection={props.sortDirection}
                        sorted={props.sortField === "balanceSixtyNinety"}
                        callback={props.sortCallback}
                     />
                  </th>
                  <th style={{ width: "10%" }}>
                     <SortHeader
                        displayName={<span>Balance <br /> 90+</span>}
                        field="balanceNinetyPlus"
                        sortDirection={props.sortDirection}
                        sorted={props.sortField === "balanceNinetyPlus"}
                        callback={props.sortCallback}
                     />
                  </th>
                  <th style={{ width: "10%" }}>
                     <SortHeader
                        displayName="YTD Sales"
                        field="yearToDateSales"
                        sortDirection={props.sortDirection}
                        sorted={props.sortField === "yearToDateSales"}
                        callback={props.sortCallback}
                     />
                  </th>
                  <th style={{ width: "10%" }}>
                     <SortHeader
                        displayName="Last Payment Date"
                        field="lastPaymentDate"
                        sortDirection={props.sortDirection}
                        sorted={props.sortField === "lastPaymentDate"}
                        callback={props.sortCallback}
                     />
                  </th>
                  <th style={{ width: "10%" }}>
                     <SortHeader
                        displayName="Last Payment Amount"
                        field="lastPaymentAmount"
                        sortDirection={props.sortDirection}
                        sorted={props.sortField === "lastPaymentAmount"}
                        callback={props.sortCallback}
                     />
                  </th>
               </tr>
            </thead>
            <tbody>
               {_.map(data, (datum, index) => {
                  return (
                     <tr key={index} className={`tr-${index % 2 === 0 ? "primary" : "secondary"}`}>
                        <td className="data-cell">
                           <span className="shredLink fw-bold"
                              onClick={() => navigate(constants.ENDPOINTS.customerDashboard, { state: { value: datum.customerId, label: datum.ddlText } })}
                           >
                              {datum.customerNumName}
                           </span>
                        </td>
                        {props.showLateBalancesOnly
                           ? <td className="data-cell" children={datum.paymentTerms} />
                           : null
                        }
                        {props.showLateBalancesOnly
                           ? <td className="data-cell" children={datum.lateBalanceDisplay} />
                           : null
                        }
                        {props.showLateBalancesOnly
                           ? <td className="data-cell" children={datum.daysPastDue} />
                           : null
                        }
                        <td className="data-cell" children={datum.customerBalanceDisplay} />
                        <td className="data-cell" children={datum.creditLimitDisplay} />
                        <td className="data-cell" children={datum.balanceThirtyDaysDisplay} />
                        <td className="data-cell" children={datum.balanceThirtySixtyDisplay} />
                        <td className="data-cell" children={datum.balanceSixtyNinetyDisplay} />
                        <td className="data-cell" children={datum.balanceNinetyPlusDisplay} />
                        <td className="data-cell" children={datum.yearToDateSalesDisplay} />
                        <td className="data-cell" children={dateHelpers.toLongDateString(datum.lastPaymentDate)} />
                        <td className="data-cell" children={datum.lastPaymentAmountDisplay} />
                     </tr>
                  );
               })}
            </tbody>
            <tfoot className="table-footer">
               <tr>
                  <td className={`fw-bold`} children="" />
                  {props.showLateBalancesOnly ? <td></td> : null}
                  {props.showLateBalancesOnly ? <td className={`fw-bold`}>{helpers.formatCurrency(pastDueTotal)}</td> : null}
                  {props.showLateBalancesOnly ? <td></td> : null}
                  <td className={`fw-bold`}>{helpers.formatCurrency(currentBalanceTotal)}</td>
                  <td></td>
                  <td className={`fw-bold`}>{helpers.formatCurrency(thirtyDaysBalanceTotal)}</td>
                  <td className={`fw-bold`}>{helpers.formatCurrency(thirtySixtyBalanceTotal)}</td>
                  <td className={`fw-bold`}>{helpers.formatCurrency(sixtyNinetyBalanceTotal)}</td>
                  <td className={`fw-bold`}>{helpers.formatCurrency(ninetyPlusBalanceTotal)}</td>
                  <td className={`fw-bold`}>{helpers.formatCurrency(yearToDateSalesTotal)}</td>
                  <td></td>
                  <td></td>
               </tr>
            </tfoot>
         </Table>
      </>
   );
}
